import * as React from 'react';

import { FormValues } from '@funnels/types';
import { FIELD_VALUES } from '@funnels/constants';

import { Panel, PanelHeading } from '../_common/style';
import { HomeLoanLayout } from '../_common/HomeLoan/layouts';

interface CurrentLoanPanelProps {
  layout: FIELD_VALUES;
  currentValues: FormValues;
}

const CurrentLoanPanel = (props: CurrentLoanPanelProps) => {
  if (props.layout !== FIELD_VALUES.REFINANCE && props.layout !== FIELD_VALUES.CONSTRUCTION_LOAN) {
    return null;
  }
  return (
    <Panel>
      <PanelHeading>Current Loan</PanelHeading>
      <HomeLoanLayout currentValues={props.currentValues} liabilityIndex={0} />
    </Panel>
  );
};

export default CurrentLoanPanel;
